module.exports = __webpack_public_path__ + "media/images/wgn_logo_banner-cbc5b85d48de6a13b1703a6db006bbe9.jpg";